export const getMenuData = [
  // --- Common & Specific Roles ---
  {
    title: 'Dashboard',
    key: '__dashboard',
    url: '/dashboard',
    icon: 'fe fe-monitor',
    roles: ['admin', 'siteManager', 'dcOwner'],
  },
  {
    title: 'EOS Monitoring',
    key: '_eos-monitoring',
    url: '/eos-monitoring',
    icon: 'fe fe-monitor',
    roles: ['eos'], // Example, adjust if needed
  },

  // --- RECEPTIONIST ---
  {
    category: true,
    title: 'RECEPTIONIST',
    key: 'category_receptionist',
    roles: ['receptionist'],
  },
  {
    title: 'Entrance System',
    key: '__entrance',
    url: '/receptionist',
    icon: 'fe fe-log-in',
    roles: ['receptionist'],
  },

  // --- SITE MANAGER ---
  // {
  //   category: true,
  //   title: 'SITE MANAGER',
  //   key: 'category_site_manager',
  //   roles: ['siteManager'],
  // },
  {
    title: 'Rollout',
    key: '__rollout',
    url: '/rollout',
    icon: 'fe fe-book',
    roles: ['dcOwner'],
  },
  {
    title: 'ATS',
    key: '__ats',
    url: '/ats',
    icon: 'fe fe-alert-circle',
    roles: ['dcOwner'],
  },

  // --- SUPER ADMIN ---
  {
    category: true,
    title: 'SUPER ADMIN',
    key: 'category_super_admin',
    roles: ['admin'],
  },
  {
    title: 'Asset Types',
    key: '__asset_types',
    url: '/asset-types',
    roles: ['admin'],
    icon: 'fe fe-box',
    children: [
      {
        title: 'Asset Categories',
        key: '__asset_kategori',
        url: '/asset-types/categories',
        // icon: 'fe fe-map',
      },
      {
        title: 'Asset Sub Categories',
        key: '__asset_subkategori',
        url: '/asset-types/sub-categories',
        // icon: 'fe fe-box',
      },
    ],
  },
  {
    title: 'Users Management',
    key: '__users',
    url: '/users',
    icon: 'fe fe-user',
    roles: ['admin'],
  },
  {
    title: 'SOPS',
    key: '__sops',
    url: '/sops',
    icon: 'fe fe-user',
    roles: ['admin'],
  },
  {
    title: 'Customers',
    key: '__customers',
    url: '/customers',
    icon: 'fe fe-users',
    roles: ['admin'],
  },
  {
    title: 'Organizations',
    key: '__organizations',
    url: '/organizations',
    icon: 'fe fe-users',
    roles: ['admin'],
  },
  {
    title: 'Vendors',
    key: '__vendors',
    url: '/vendors',
    icon: 'fe fe-box',
    roles: ['admin', 'siteManager', 'dcOwner'],
  },
  {
    title: 'Approval',
    key: '__approval',
    url: '/approval',
    icon: 'fe fe-box',
    roles: ['siteManager'],
  },

  // --- EOS ---
  {
    category: true,
    title: 'EOS',
    key: 'category_eos',
    roles: ['eos'],
  },
  {
    title: 'Monitoring',
    key: '__monitoring',
    url: '/monitoring',
    icon: 'fe fe-video',
    roles: ['eos'],
  },

  // --- HELPDESK ---
  {
    category: true,
    title: 'HELPDESK',
    key: 'category_helpdesk',
    roles: ['helpDesk', 'eos'],
  },
  {
    title: 'Change Request',
    key: '__change_request',
    url: '/request',
    icon: 'fe fe-layers',
    roles: ['helpDesk', 'eos'],
  },
  {
    title: 'Troubleshoot',
    key: '__troubleshoot',
    url: '/monitoring/troubleshoot',
    icon: 'fe fe-settings',
    roles: ['helpDesk'],
  },
  {
    title: 'Addition',
    key: '__activeMonitoring',
    url: '/monitoring/addition',
    icon: 'fe fe-plus-square',
    roles: ['helpDesk'],
  },
  {
    title: 'Dismantle',
    key: '__dismantle',
    url: '/monitoring/dismantle',
    icon: 'fe fe-minus-square',
    roles: ['helpDesk'],
  },
  {
    title: 'Testing',
    key: '__testing',
    url: '/monitoring/testing',
    icon: 'fe fe-check-square',
    roles: ['helpDesk'],
  },

  // --- MASTER DATA / BASE ---
  {
    title: 'Base',
    key: '__base',
    url: '/base',
    icon: 'fe fe-map',
    roles: ['admin', 'siteManager'], // Only admin can access the base master data menu
    children: [
      {
        title: 'Lokasi',
        key: '__lokasi',
        url: '/base/lokasi',
      },
      {
        title: 'Ruangan',
        key: '__ruangan',
        url: '/base/ruangan',
      },
      {
        title: 'Manufaktur',
        key: '__manufaktur',
        url: '/base/manufaktur',
      },
    ],
  },

  // --- MENU PENDUKUNG (Visible to all) ---
  {
    category: true,
    title: 'Menu Pendukung',
    key: 'category_support',
  },
  {
    title: 'Profil',
    key: '__akun',
    url: '/akun',
    icon: 'fe fe-users',
    // No 'roles' property means it's visible to all logged-in users
  },
]
